import type {
    AdNetworksTableDto,
    AdNetworksTableRowDto,
    AdNetworksTableRowViewModel,
} from "../../company/types/ad-networks";

type WorldwideOverviewParams = Record<string, unknown> & {
    key: string;
};

export type AdNetworksTableRow = AdNetworksTableRowViewModel;

export const normalizeAdNetworksTableResponse = (response: AdNetworksTableDto | undefined): AdNetworksTableRowDto[] =>
    response?.data ?? [];

export const mapAdNetworksTableRows = (
    rows: AdNetworksTableRowDto[] | undefined,
    getRowUrl: (domain: string) => string,
): AdNetworksTableRow[] => {
    if (!rows?.length) {
        return [];
    }

    return rows.map((record) => ({
        Domain: record.domain,
        TotalShare: record.totalShare,
        SiteOrigins: record.siteOrigins,
        url: getRowUrl(record.domain),
    }));
};

export const createAdNetworksRowUrlBuilder =
    (params: WorldwideOverviewParams, hrefBuilder: (state: string, params: WorldwideOverviewParams) => string) =>
    (domain: string): string =>
        hrefBuilder("digitalsuite_website_websiteperformance", {
            ...params,
            key: domain,
        });
